import "core-js/modules/es.array.reverse.js";
var _class, _ShapefileCatalogItem;
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url.js";
import "core-js/modules/web.url.to-json.js";
import "core-js/modules/web.url-search-params.js";
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
import i18next from "i18next";
import { action, computed, makeObservable } from "mobx";
import { parseZip } from "shpjs";
import { isJsonObject } from "../../../Core/Json";
import loadBlob, { isZip } from "../../../Core/loadBlob";
import TerriaError from "../../../Core/TerriaError";
import GeoJsonMixin from "../../../ModelMixins/GeojsonMixin";
import ShapefileCatalogItemTraits from "../../../Traits/TraitsClasses/ShapefileCatalogItemTraits";
import CommonStrata from "../../Definition/CommonStrata";
import CreateModel from "../../Definition/CreateModel";
import proxyCatalogItemUrl from "../proxyCatalogItemUrl";
import { fileApiNotSupportedError } from "./GeoJsonCatalogItem";
export function isJsonArrayOrDeepArrayOfObjects(value) {
  return Array.isArray(value) && value.every(child => isJsonObject(child) || isJsonArrayOrDeepArrayOfObjects(child));
}
let ShapefileCatalogItem = (_class = (_ShapefileCatalogItem = class ShapefileCatalogItem extends GeoJsonMixin(CreateModel(ShapefileCatalogItemTraits)) {
  constructor() {
    super(...arguments);
    makeObservable(this);
  }
  get type() {
    return ShapefileCatalogItem.type;
  }
  get typeName() {
    return i18next.t("models.shapefile.name");
  }
  setFileInput(file) {
    this.setTrait(CommonStrata.user, "url", URL.createObjectURL(file) + "#" + file.name);
  }
  get hasLocalData() {
    var _this$url$startsWith, _this$url;
    return (_this$url$startsWith = (_this$url = this.url) === null || _this$url === void 0 ? void 0 : _this$url.startsWith("blob:")) !== null && _this$url$startsWith !== void 0 ? _this$url$startsWith : false;
  }
  async forceLoadGeojsonData() {
    if (this.url) {
      if (this.hasLocalData || isZip(this.url)) {
        if (typeof FileReader === "undefined") {
          throw fileApiNotSupportedError(this.terria);
        }
        const blob = await loadBlob(proxyCatalogItemUrl(this, this.url));
        return await parseShapefile(blob);
      } else {
        throw TerriaError.from("Invalid URL: Only zipped shapefiles are supported (the extension must be `.zip`)");
      }
    }
    throw TerriaError.from("Failed to load shapefile - no URL of file has been defined");
  }
}, _defineProperty(_ShapefileCatalogItem, "type", "shp"), _ShapefileCatalogItem), _applyDecoratedDescriptor(_class.prototype, "setFileInput", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setFileInput"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hasLocalData", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasLocalData"), _class.prototype), _class);
const mergeFeatureCollections = items => {
  const output = {
    type: "FeatureCollection",
    features: []
  };
  for (let i = 0; i < items.length; i++) {
    const item = items[i];
    for (let j = 0; j < item.features.length; j++) {
      output.features.push(item.features[j]);
    }
  }
  return output;
};
async function parseShapefile(blob) {
  const asAb = await blob.arrayBuffer();
  const json = await parseZip(asAb);
  if (isJsonArrayOrDeepArrayOfObjects(json)) {
    return mergeFeatureCollections(json);
  }
  return json;
}
export default ShapefileCatalogItem;